import type { FC } from 'react';
import type React from 'react';
import CloseRounded from '@mui/icons-material/CloseRounded';
import type { SnackbarContentProps, SnackbarProps } from '@mui/material';
import {
  Box,
  IconButton,
  Snackbar,
  SnackbarContent,
  Stack,
  Typography,
} from '@mui/material';

import { styles } from './index.styles';

export interface BaseSnackbarProps {
  onClose: () => void;
  open: NonNullable<SnackbarProps['open']>;
  snackbarProps?: SnackbarProps;
  snackbarContentProps?: SnackbarContentProps;
  title?: string;
  message?: string;
  leftColumn?: React.ReactNode;
  testId?: string;
}

const BaseSnackbar: FC<BaseSnackbarProps> = ({
  onClose,
  open,
  snackbarProps,
  snackbarContentProps,
  title,
  message,
  leftColumn,
  testId,
}) => (
  <Snackbar
    autoHideDuration={6000}
    onClose={onClose}
    open={open}
    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    {...snackbarProps}
  >
    <SnackbarContent
      data-test-id={testId}
      sx={styles.baseSnackbarContainer}
      message={
        <Stack direction="row">
          {leftColumn && (
            <Stack
              direction="column"
              sx={{
                justifyContent: 'center',
              }}
            >
              {leftColumn}
            </Stack>
          )}

          <Stack sx={styles.baseSnackbarText}>
            {title !== undefined && (
              <Typography
                variant="h6"
                sx={{ fontSize: '18px', lineHeight: '1.75rem' }}
              >
                {title}
              </Typography>
            )}
            {message !== undefined && <Box>{message}</Box>}
          </Stack>
        </Stack>
      }
      action={
        <IconButton
          size="large"
          aria-label="close"
          color="primary"
          onClick={onClose}
        >
          <CloseRounded color="primary" />
        </IconButton>
      }
      {...snackbarContentProps}
    />
  </Snackbar>
);

export default BaseSnackbar;
